import React from "react";

export default function InfoCard({ icon, title, value }) {
  return (
    <div className="bg-white rounded-2xl p-4 shadow-[0px_4px_20px_rgba(0,0,0,0.02)] border border-gray-100 flex-1 min-w-0">
      <div className="text-tuncayBlue text-xl mb-2">{icon}</div>

      <p className="text-gray-500 text-sm font-medium">{title}</p>

      <p className="text-base md:text-lg font-bold text-gray-800 mt-0.5 truncate">
        {value}
      </p>
    </div>
  );
}

